import { render } from "./inspectionRecords.vue?vue&type=template&id=9bf5f968&scoped=true"
import script from "./inspectionRecords.vue?vue&type=script&lang=js"
export * from "./inspectionRecords.vue?vue&type=script&lang=js"

import "./inspectionRecords.vue?vue&type=style&index=0&id=9bf5f968&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9bf5f968"

export default script